import { Fingerprint } from "lucide-react";

/**
 * Cinematic biometric fingerprint orb used in hero / final CTA.
 * Pure CSS — no external assets. Cool blue glow + warm orange ring.
 */
export const FingerprintOrb = ({ size = 280 }) => (
  <div
    className="relative"
    style={{ width: size, height: size }}
    data-testid="fingerprint-orb"
    aria-hidden="true"
  >
    {/* Outer rings */}
    <div className="absolute inset-0 rounded-full border border-[#06102A]/10" />
    <div
      className="absolute inset-4 rounded-full border border-[#3B82F6]/30 vt-pulse"
      style={{ animationDelay: "0s" }}
    />
    <div
      className="absolute inset-10 rounded-full border border-[#F97316]/30 vt-pulse"
      style={{ animationDelay: "1.2s" }}
    />

    {/* Inner glow */}
    <div
      className="absolute inset-12 rounded-full"
      style={{
        background:
          "radial-gradient(circle at 50% 45%, rgba(59,130,246,0.25) 0%, rgba(59,130,246,0.05) 50%, transparent 80%)",
      }}
    />

    {/* Metallic core */}
    <div
      className="absolute inset-16 rounded-full"
      style={{
        background:
          "radial-gradient(circle at 30% 25%, #FFFFFF 0%, #E9EBEF 40%, #C9CDD6 100%)",
        boxShadow:
          "inset 0 -10px 30px rgba(6,16,42,0.18), inset 0 6px 20px rgba(255,255,255,0.9), 0 30px 60px -20px rgba(6,16,42,0.25)",
      }}
    />

    {/* Fingerprint icon */}
    <Fingerprint
      className="absolute inset-0 m-auto text-[#06102A]"
      style={{ width: size * 0.32, height: size * 0.32, opacity: 0.85 }}
      strokeWidth={1.25}
    />

    {/* Orange energy spark */}
    <span
      className="absolute right-[18%] top-[18%] h-2 w-2 rounded-full"
      style={{
        background: "#F97316",
        boxShadow: "0 0 18px 4px rgba(249,115,22,0.55)",
      }}
    />
  </div>
);

export default FingerprintOrb;
